export const dataType = [
  {
    label: "充电桩登录认证",
    value: "充电桩登录认证"
  },
  {
      label: "登录认证应答",
      value: "登录认证应答"
  },
  {
      label: "充电桩心跳包",
      value: "充电桩心跳包"
  },
  {
      label: "心跳包应答",
      value: "心跳包应答"
  },
  {
      label: "计费模型验证请求",
      value: "计费模型验证请求"
  },
  {
      label: "计费模型验证请求应答",
      value: "计费模型验证请求应答"
  },
  {
      label: "充电桩计费模型请求",
      value: "充电桩计费模型请求"
  },
  {
      label: "计费模型请求应答",
      value: "计费模型请求应答"
  },
  {
      label: "读取实时监测数据",
      value: "读取实时监测数据"
  },
  {
      label: "离线监测数据",
      value: "离线监测数据"
  },
  {
      label: "充电握手",
      value: "充电握手"
  },
  {
      label: "参数配置",
      value: "参数配置"
  },
  {
      label: "充电结束",
      value: "充电结束"
  },
  {
      label: "错误报文",
      value: "错误报文"
  },
  {
      label: "充电阶段BMS中止",
      value: "充电阶段BMS中止"
  },
  {
      label: "充电阶段充电机中止",
      value: "充电阶段充电机中止"
  },
  {
      label: "充电过程BMS需求、充电机输出",
      value: "充电过程BMS需求、充电机输出"
  },
  {
      label: "充电过程BMS信息",
      value: "充电过程BMS信息"
  },
  {
      label: "充电桩主动申请启动充电",
      value: "充电桩主动申请启动充电"
  },
  {
      label: "运营平台确认启动充电",
      value: "运营平台确认启动充电"
  },
  {
      label: "远程启机命令回复",
      value: "远程启机命令回复"
  },
  {
      label: "运营平台远程控制启机",
      value: "运营平台远程控制启机"
  },
  {
      label: "远程停机命令回复",
      value: "远程停机命令回复"
  },
  {
      label: "运营平台远程停机",
      value: "运营平台远程停机"
  },
  {
      label: "交易记录",
      value: "交易记录"
  },
  {
      label: "交易记录确认",
      value: "交易记录确认"
  },
  {
      label: "余额更新应答",
      value: "余额更新应答"
  },
  {
      label: "远程账户余额更新",
      value: "远程账户余额更新"
  },
  {
      label: "卡数据同步应答",
      value: "卡数据同步应答"
  },
  {
      label: "离线卡数据同步",
      value: "离线卡数据同步"
  },
  {
      label: "离线卡数据清除应答",
      value: "离线卡数据清除应答"
  },
  {
      label: "离线卡数据清除",
      value: "离线卡数据清除"
  },
  {
      label: "离线卡数据查询应答",
      value: "离线卡数据查询应答"
  },
  {
      label: "离线卡数据查询",
      value: "离线卡数据查询"
  },
  {
      label: "充电桩工作参数设置应答",
      value: "充电桩工作参数设置应答"
  },
  {
      label: "充电桩工作参数设置",
      value: "充电桩工作参数设置"
  },
  {
      label: "对时设置应答",
      value: "对时设置应答"
  },
  {
      label: "对时设置",
      value: "对时设置"
  },
  {
      label: "计费模型应答",
      value: "计费模型应答"
  },
  {
      label: "计费模型设置",
      value: "计费模型设置"
  },
  {
      label: "地锁数据上送（充电桩上送）",
      value: "地锁数据上送（充电桩上送）"
  },
  {
      label: "遥控地锁升锁与降锁命令（下行）",
      value: "遥控地锁升锁与降锁命令（下行）"
  },
  {
      label: "充电桩返回数据（上行）",
      value: "充电桩返回数据（上行）"
  },
  {
      label: "远程重启应答",
      value: "远程重启应答"
  },
  {
      label: "远程重启",
      value: "远程重启"
  },
  {
      label: "远程更新应答",
      value: "远程更新应答"
  },
  {
      label: "远程更新",
      value: "远程更新"
  }
]



// WEBPACK FOOTER //
// ./src/utils/interactive.js